import { PayloadAction, createSlice } from "@reduxjs/toolkit"

// Tracks which pads have been played, per soundboard. Whether played pads are
// actually dimmed is a persistent soundboard property (`dimPlayedTracks`); this
// slice only holds the ephemeral played set. Persisted redux state is a happy
// medium: it survives navigating away from a soundboard, but resetting (via the
// "Reset played" toolbar button) is a deliberate act.
export interface PlayedTracksState {
  playedPads: { [soundboardUuid: string]: string[] }
}

const initialState: PlayedTracksState = {
  playedPads: {},
}

// Not exported: exporting the slice object surfaces its immer `WritableDraft`
// types in the emitted declarations, which aren't portable (TS2742/2883). Only
// the action creators and reducer are exported.
const playedTracksSlice = createSlice({
  name: "playedTracks",
  initialState,
  reducers: {
    markPadPlayed: (
      state,
      action: PayloadAction<{ soundboardUuid: string; padUuid: string }>,
    ) => {
      const { soundboardUuid, padUuid } = action.payload
      const existing = state.playedPads[soundboardUuid] || []
      if (!existing.includes(padUuid))
        state.playedPads[soundboardUuid] = [...existing, padUuid]
    },
    resetPlayedPads: (
      state,
      action: PayloadAction<{ soundboardUuid: string }>,
    ) => {
      state.playedPads[action.payload.soundboardUuid] = []
    },
  },
})

export const { markPadPlayed, resetPlayedPads } = playedTracksSlice.actions

export default playedTracksSlice.reducer
